import React from 'react';
import { connect } from 'react-redux';
import { getMailFrom } from '../selectors';

const stateToProps = state => ({
  mailFrom: getMailFrom(state),
});

const ThankYouPage = props => {

  return (
    <form className="reg-form table-cell">
      <div className="registration-status success">
        <p className="head--txt">
          Almost there!
        </p>

        <p className="intro--txt ml10 mt15">
          Your account has been created and an activation link has been sent to the phone number you supplied (as well as the email address, if you provided it). Please note that you must activate the account in
          <span className="txt-hl">24 hours</span>
          by clicking on the activation link in either the SMS or email before you can log in.
        </p>

        <p className="intro--txt ml10">
          Please check your phone's global Do Not Disturb and make sure you are opted out so you can receive the SMS.
        </p>

        <p className="intro--txt ml10">
          If you provided the email address and cannot find the activation email in your inbox,
          please check the spam/trash folders and make sure you add
            <span className="txt-mail">{props.mailFrom}</span>
            to your approved senders list.
        </p>
      </div>
    </form>
  );
}

export default connect(
    stateToProps,
    null
)(ThankYouPage);